import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import getActionCreators from '@redux/getActionCreators';
import { useInjectResourceControllerReducer } from '@redux/getReducer';
import getSelectors from '@redux/getSelectors';
import { constructValidationChecker, validationCheck } from '@validation/validation';
import { Form } from 'antd';
import { createStructuredSelector } from 'reselect';

export type TUseReduxForm = {
  form: any;
  formData: any;
  formFieldsError: any;
  validationChecker: any;
  setFormData: any;
  checkFields: any;
  handleSubmit: any;
};

export function useReduxForm(
  reduxActionName: string,
  request?: (data: any) => any,
  onConfirm?: (params: Record<any, any>) => Promise<boolean> | boolean,
): TUseReduxForm {
  const { makeSelectParamsForRequest } = getSelectors(reduxActionName);
  useInjectResourceControllerReducer(reduxActionName);
  const { paramsForRequest = {} } = useSelector(
    createStructuredSelector({
      paramsForRequest: makeSelectParamsForRequest(),
    }),
  );
  const { setParamsForRequest } = getActionCreators(reduxActionName);

  const validationChecker = constructValidationChecker(reduxActionName);

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  function setFormData(name: string, value: any) {
    dispatch(setParamsForRequest({ [name]: value }));
    form.setFieldsValue({ [name]: value });
  }
  function setFormDataObject(obj: Record<any, any>) {
    dispatch(setParamsForRequest(obj));
    form.setFieldsValue(obj);
  }
  const [formFieldsError, setFormFieldsError] = useState<Record<any, any>>();

  function checkFields() {
    const formError = validationCheck({ reduxActionName, formData: paramsForRequest });
    setFormFieldsError(formError);
    return formError;
  }

  async function handleSubmit() {
    const formError = checkFields();
    if (Object.keys(formError).length === 0) {
      if (!onConfirm || (await onConfirm(paramsForRequest as Record<any, any>))) {
        request?.(paramsForRequest);
      }
    }
  }

  return {
    form,
    formData: paramsForRequest,
    formFieldsError,
    validationChecker: (name: string | number | (string | number)[], value: any, _formData: any) =>
      validationChecker(name, value, _formData),
    setFormData: (param1: string | Record<any, any>, value?: any) => {
      if (typeof param1 === 'string') setFormData(param1, value);
      if (typeof param1 === 'object') setFormDataObject(param1);
    },
    checkFields: () => checkFields(),
    handleSubmit: () => handleSubmit(),
  };
}
